import script from "./MilestoneTeacherCheck.vue?vue&type=script&setup=true&lang=ts"
export * from "./MilestoneTeacherCheck.vue?vue&type=script&setup=true&lang=ts"

import "./MilestoneTeacherCheck.vue?vue&type=style&index=0&id=777e310d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-777e310d"]])

export default __exports__